export default "__VITE_ASSET__ad7c1315__"